import React, { useEffect } from "react";

import { ThemeProvider } from "@/lib/context/ThemeContext";
import { Toaster } from "react-hot-toast";
import { Head, usePage } from "@inertiajs/react";
import { AppToast } from "@/services/toast";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

const BaseLayout = ({ children }: { children: React.ReactNode }) => {

  const { errors , success , info , global_data } = usePage<PageProps>().props;

  useEffect(() => {
    if (errors && errors.message) {
      AppToast.error(errors.message);
    }
  }, []);

  useEffect(() => {
    if (success) {
      AppToast.success(success);
    }
  }, []);

  useEffect(() => {
    if (info) {
      AppToast.info(info);
    }
  }, []);
  
  

  
  return (
    <ThemeProvider>

      <Head>
        <title>{global_data.company.name}</title>
        <meta name="description" content={global_data.company.description} />
        <meta property="og:title" content={global_data.company.name} />
        {/* <meta property="og:description" content={global_data.company.description} /> */}
        <meta property="og:image" content={global_data.logo} />

        {/* <link rel="canonical" href={window.location.href} /> */}
        <meta property="og:type" content="website" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        
      </Head>
      <Toaster />
      <FloatingWhatsApp />

      {children}
    </ThemeProvider>
  );
};

export default BaseLayout;
